export default __webpack_public_path__ + "static/media/benefits.b7e883dd.svg";